<app-section-free-mock [title]="'My Study'"></app-section-free-mock>

<app-section-study-materials></app-section-study-materials>